module.exports = __webpack_public_path__ + "img/noticedetail-b.2936364e.png";